import { render, staticRenderFns } from "./IntroSecondPage.vue?vue&type=template&id=61cfbb51&scoped=true&"
import script from "./IntroSecondPage.vue?vue&type=script&lang=js&"
export * from "./IntroSecondPage.vue?vue&type=script&lang=js&"
import style0 from "./IntroSecondPage.vue?vue&type=style&index=0&id=61cfbb51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cfbb51",
  null
  
)

export default component.exports